import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons"

const FullscreenImageTextBlock = ({ block }) => {
  return (
    <BlockWrapper block={block} blockWidth="screen" showHeadline="false">
      <div className="w-full h-[50vh] xl:h-[80vh] overflow-hidden">
        <Image className="object-cover w-full h-full" image={block.image} />
      </div>
      <div className="max-w-screen-xl px-8 pt-8 mx-auto text-center transform bg-white xl:pb-8 xl:px-16 xl:shadow-xl xl:-translate-y-48 xl:-mb-48">
        <HeadlineEnhanced
          kicker={block.kicker}
          headline={block.headline}
          subheadline={block.subheadline}
        />
        {block.text?.length > 0 && (
          <Richtext className="mt-8" text={block.text} />
        )}
        {block.link_text?.length > 0 && (
          <Link
            className="inline-block mt-4 font-bold hover:text-primary-hover"
            link={block.link}
          >
            {block.link_text}
            <FontAwesomeIcon icon={faArrowRight} size="1x" className="ml-2" />
          </Link>
        )}
      </div>
    </BlockWrapper>
  )
}

export default FullscreenImageTextBlock
